// extracted by mini-css-extract-plugin
export default {"crypto":"icons_crypto__y4NHL","inst":"icons_inst__PEi1Z","cash":"icons_cash__s7jCX","card":"icons_card__uBbbK","bank":"icons_bank__kSi9G"};